import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { bypassBlocker } from '~/constants/router';
import { routes } from '~/providers/RouterProvider/router.routes';

import { fetchJson } from '../fetch';
import { sessionEnded } from '../session';

export const useLogout = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: () => {
      return fetchJson('/authentication/logout', {
        method: 'POST',
      });
    },
    onSettled: () => {
      if (window.productFruits) {
        const pf = window.productFruits as { services: { destroy: () => void } };
        pf.services.destroy();
      }

      sessionEnded.notify({ otherTabsOnly: true });

      navigate(routes.login, { replace: true, state: bypassBlocker });
    },
  });
};
